var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.75 7.25V2.25H7.25V7.25H2.25V8.75H7.25V13.75H8.75V8.75H13.75V7.25H8.75Z","fill":"#181818"}));
}

Plus.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Plus;

Plus.default = Plus;
